module.exports = __webpack_public_path__ + "static/img/bip6.7fc31af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bip6.png
// module id = lZKA
// module chunks = 73